module.exports = __webpack_public_path__ + "static/media/taladro-black-decker.b9857907.png";